/** The parts every pushed phone screen is made of, as the prototype draws them. */
import type { ReactNode } from "react";
import { useGoBack } from "../components/phone/history";
import { Icon, type IconName } from "../components/ui/Icon";
import { talkPath } from "./places";

/** A pushed screen's head: Back, the title with one line under it, one or two things on the right. */
export function Nav({ back, to = talkPath, title, sub, right, onSub, subLabel }: { back: string; to?: string; title: ReactNode; sub?: ReactNode; right?: ReactNode; onSub?: () => void; subLabel?: string }) {
  const goBack = useGoBack();
  return (
    <header className="hp-nav">
      <button type="button" className="hp-back" onClick={() => goBack(to)}>
        <Icon name="left" />
        {back}
      </button>
      <span className="hp-nav-t">
        <b>{title}</b>
        {sub ? (
          onSub ? (
            <small>
              <button type="button" className="hp-sub-b" aria-label={subLabel} onClick={onSub}>
                {sub}
              </button>
            </small>
          ) : (
            <small>{sub}</small>
          )
        ) : null}
      </span>
      <span className="hp-nav-r">{right}</span>
    </header>
  );
}

/** A row in a phone card: an icon, a name, a count or a dot, and a chevron. */
export function Row({ icon, label, end, on, accent, onClick }: { icon: IconName; label: string; end?: ReactNode; on?: boolean; accent?: boolean; onClick?: () => void }) {
  return (
    <button type="button" className={accent ? "hp-row add" : on ? "hp-row on" : "hp-row"} onClick={onClick}>
      <Icon name={icon} />
      <span className="hp-row-n">{label}</span>
      {end}
      {accent ? null : <Icon name="chev" />}
    </button>
  );
}

export const newCount = (k: number) => <i className="hp-n">{k}</i>;
export const plainCount = (k: number) => <span className="hp-c">{k}</span>;
